export const paneItemStyles = {
  height: '100%',
  minWidth: 0,
  overflow: 'hidden',
};
